module.exports = __webpack_public_path__ + "3685afd783db72f648200ac25acefa43.jpg";